(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        (function () {
            function initGuideSwipers() {
                if (typeof Swiper === 'undefined') {
                    return;
                }

                var sliders = document.querySelectorAll('.js-guide-gallery-swiper');
                Array.prototype.forEach.call(sliders, function (slider) {
                    new Swiper(slider, {
                        slidesPerView: 'auto',
                        spaceBetween: 8,
                        watchOverflow: true
                    });
                });
            }

            function bindExcursionsExternalLink(linkElement) {
                linkElement.addEventListener('click', function (event) {
                    if (typeof window.openExternalURL !== 'function') {
                        return;
                    }

                    var excursionsSection = linkElement.closest('.guide-card');
                    if (!excursionsSection || !excursionsSection.querySelector('.excursions-by-region-widget .excursions-card')) {
                        return;
                    }

                    var link = linkElement.getAttribute('href') || '';
                    if (link === '' || link === '#') {
                        return;
                    }

                    event.preventDefault();
                    // метод реализует Web View Js Bridge в приложении
                    window.openExternalURL(link, false);
                });
            }

            function initExcursionsExternalLinks() {
                var links = document.querySelectorAll('.excursions-by-region-widget .excursions-card, .guide-excursions-link');
                if (!links.length) {
                    return;
                }

                Array.prototype.forEach.call(links, bindExcursionsExternalLink);
            }

            initGuideSwipers();
            initExcursionsExternalLinks();
        })();
    }, {}] }, {}, [1]);